import { get, writable } from 'svelte/store';
import {
	cycleDashLightingPackId,
	getDashLightingPack,
	type DashLightingPack,
	type DashLightingPackId,
} from 'src/helpers/dash-lighting';

const STORAGE_KEY = 'shelly_dev_dash_lighting_pack';

const isPackId = (value: string | null): value is DashLightingPackId =>
	value === 'default' || value === 'glow-all' || value === 'opaque-all';

const readInitialValue = (): DashLightingPackId => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		return isPackId(raw) ? raw : 'default';
	} catch {
		return 'default';
	}
};

/**
 * Dev-only active dash card feedback pack.
 * Affects all DashDeviceQuickControl / DashDeviceCard resolvers while set.
 * Default production look is `default` unless overridden here.
 */
export const dashLightingPackId = writable<DashLightingPackId>(readInitialValue());

dashLightingPackId.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, value);
	} catch {
		// localStorage may be unavailable
	}
});

export const getDashLightingPackId = (): DashLightingPackId => get(dashLightingPackId);

export const setDashLightingPackId = (id: DashLightingPackId) => {
	dashLightingPackId.set(id);
};

export const cycleDashLightingPack = (): DashLightingPackId => {
	const next = cycleDashLightingPackId(get(dashLightingPackId));
	dashLightingPackId.set(next);
	return next;
};

export const getActiveDashLightingPack = (): DashLightingPack =>
	getDashLightingPack(get(dashLightingPackId));
